module.exports = __webpack_public_path__ + "static/first-race-fd04360509c3e0c879b8c5e51fbd0bb8.jpg";